/** 与 shake-lottery.js 摇一摇抽奖共用，修改时请同步两处行为 */

export const SHAKE_SAMPLE_INTERVAL_MS = 80
/** 单次采样 delta 阈值，越低越容易触发 */
export const SHAKE_DELTA_THRESHOLD = 11
export const SHAKE_PEAKS_REQUIRED = 2
export const SHAKE_PEAK_WINDOW_MS = 3800
export const SHAKE_PEAK_MIN_GAP_MS = 120
/** 从首次有效峰值起的最短持续时长，越低越容易触发 */
export const SHAKE_MIN_DURATION_MS = 500
export const SHAKE_DRAW_COOLDOWN_MS = 1200
export const SHAKE_DRAWING_DELAY_MS = 1400

export const SHAKE_VISUAL_MIN_DELTA = 0.4
export const SHAKE_VISUAL_MAX_PX = 34
export const SHAKE_VISUAL_MAX_DEG = 24
export const SHAKE_VISUAL_IMPULSE_XY = 2.4
export const SHAKE_VISUAL_IMPULSE_ROT = 1.15
export const SHAKE_VISUAL_DECAY = 0.86

export const SHAKE_MOTION_CONFIG_ITEMS = [
	{ key: 'SHAKE_SAMPLE_INTERVAL_MS', label: '采样间隔', unit: 'ms' },
	{ key: 'SHAKE_DELTA_THRESHOLD', label: '晃动阈值(delta)', unit: '' },
	{ key: 'SHAKE_PEAKS_REQUIRED', label: '有效峰值次数', unit: '次' },
	{ key: 'SHAKE_PEAK_WINDOW_MS', label: '峰值统计窗口', unit: 'ms' },
	{ key: 'SHAKE_PEAK_MIN_GAP_MS', label: '峰值最小间隔', unit: 'ms' },
	{ key: 'SHAKE_MIN_DURATION_MS', label: '最短持续时长', unit: 'ms' },
	{ key: 'SHAKE_DRAW_COOLDOWN_MS', label: '触发冷却', unit: 'ms' }
]

export function getShakeMotionConfigValues() {
	return {
		SHAKE_SAMPLE_INTERVAL_MS,
		SHAKE_DELTA_THRESHOLD,
		SHAKE_PEAKS_REQUIRED,
		SHAKE_PEAK_WINDOW_MS,
		SHAKE_PEAK_MIN_GAP_MS,
		SHAKE_MIN_DURATION_MS,
		SHAKE_DRAW_COOLDOWN_MS
	}
}
